import { Box, CircularProgress } from "@mui/material";

export default function LoaderScreen() {
    return (
        <Box
            sx={{
                position: "fixed",
                inset: 0,
                zIndex: 9999,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "var(--offwhite)",
                pointerEvents: "none",
            }}
        >
            <CircularProgress
                size={56}
                thickness={4.5}
                sx={{
                    color: "var(--azulEscuro)",
                }}
            />
        </Box>
    );
}